<template>
  <img :src="currentImage" :width="size" :height="size" />
</template>

<script>
export default {
  name: 'CheckIcon',
  props: {
    check: Boolean,
    size: {
      type: Number,
      default: 16
    }
  },
  computed: {
    currentImage() {
      return this.check ? '/img/obs/icon_enabled.png' : '/img/obs/icon_disabled.png';
    }
  }
};
</script>

<style scoped></style>
